// extracted by mini-css-extract-plugin
module.exports = {"heading3":"styles_heading3__14P2c"};